import { Box } from '@material-ui/core'
import React from 'react'

import styled from 'styled-components'
import { shape, theme } from '../../theme'

const Bar = styled.div<{ $progress: number }>`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: ${p => (p.$progress * 100) + '%'};
	background: ${theme.palette.primary.main};
`

export default function HealthBar({ progress = 0 }) {
	return (
		<Box width="150px" height="12px" position="relative" borderRadius={shape.borderRadius} overflow="hidden" bgcolor="rgba(255,255,255,0.25)" border="2px solid rgba(255,255,255,0.25)">
			<Bar $progress={progress} />
		</Box>
	)
}
